export const DEFAULT_LOCALE = 'jp'

// Mobile size is smaller than or equal 1080px (include )
export const BREAKPOINT_TABLET = 1080

// Mobile size is smaller than or equal 1080px (include tablet)
export const BREAKPOINT_MOBILE = 768
